import { render, staticRenderFns } from "./UkraineProjected.vue?vue&type=template&id=bcd0fc62&"
import script from "./UkraineProjected.vue?vue&type=script&lang=js&"
export * from "./UkraineProjected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports